import { useTranslation } from 'react-i18next';

import MainTitle from '../common/MainTitle';
import ImageLink from '../../js/utils/ImageLink';

/**
 *
 * @param {{ data:array }} props
 * @returns
 */

export default function BenefitsPolices({ data }) {
  const { t } = useTranslation(['CareersPage']);

  return (
    <section className="benefits-tabs container">
      <div className="title">
        <MainTitle type="dark" className="text--2xl">
          <span>{t('benefits')}</span>
          <span className="decorated-line decorated-line--dark decorated-line--left">
            {t('andPolicies')}
          </span>
        </MainTitle>
      </div>

      <div className="content">
        {data.map(({ id, text, image, url, title }, index) => (
          <div
            key={`tabs-container-${id}`}
            className={`benefits-tabs__content-container ${index % 2 !== 0 ? 'reversed' : ''}`}>
            <div className="benefits-tabs__header mobile">
              <MainTitle type="dark">
                <span>{t(title)}</span>
              </MainTitle>
              <p>{text}</p>
            </div>

            <div className="benefits-tabs__content">
              <div className="benefits-tabs__header desktop">
                <MainTitle type="dark">
                  <span>{title}</span>
                </MainTitle>
                <p>{text}</p>
              </div>
            </div>

            <div className="benefits-tabs__media">
              <picture>
                <source srcSet={ImageLink(image.url)} type="image/webp" />
                <img src={ImageLink(image.url)} alt="Teachers having a meeting" />
              </picture>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
